export const CartageItemTypes = [ 'pickup', 'delivery', 'linehaul' ] as const;
export type CartageItemTypes = typeof CartageItemTypes[ number ];
